import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledPaginationWrapper: any = styled.div`
  width: 100%;

  .pagination {
    display: flex;
    justify-content: flex-end;
    list-style: none;
    cursor: pointer;
    padding-inline: 0;
    -webkit-tap-highlight-color: transparent;

    &:focus-visible {
      outline: none;
    }

    @media (min-width: ${Breakpoints.b560}px) {
      margin-left: 40%;
    }

    @media (min-width: ${Breakpoints.b960}px) {
      margin-left: 60%;
    }

    @media (min-width: ${Breakpoints.b1280}px) {
      margin-left: 68%;
    }

    @media (min-width: ${Breakpoints.b1920}px) {
      margin-left: 75%;
    }

    li {
      width: 100%;
      max-width: 70.3px;

      @media (min-width: ${Breakpoints.b560}px) {
        max-width: 56.4px;
      }

      @media (min-width: ${Breakpoints.b960}px) {
        max-width: 51.4px;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        max-width: 53.4px;
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        max-width: 60px;
      }

      &.previous,
      &.next {
        width: 10%;
      }

      &.previous {
        @media (min-width: ${Breakpoints.b560}px) {
          margin-right: 6%;
        }
      }

      &.next {
        @media (min-width: ${Breakpoints.b560}px) {
          margin-left: 6%;
        }
      }
    }

    a {
      padding: 10px 0;
      color: #001e50;
      border-bottom: solid 1px #dfe4e8;
      width: 100%;
      display: block;
      text-align: center;

      &.pagination__link--previous,
      &.pagination__link--next {
        border-bottom: none;
      }

      &.pagination__link--previous {
        padding-left: 0;
        padding-right: 8px;
      }

      &.pagination__link--next {
        padding-left: 8px;
        padding-right: 0;
      }
    }

    .break {
      display: none;
    }

    .pagination__link--active a {
      color: #001e50;
      border-bottom: #001e50 2px solid;
    }

    .pagination__link--disabled a {
      color: #fff;
    }
  }
`;
